<template>
  <v-container class="mb-5" grid-list-md text-center>
    <div class="addcell-content">
      <!-- <v-row>
        <v-col cols="12">
          <p class="headline">Choose cells required of battery</p>
        </v-col>
      </v-row>
      <v-row class="justify-center">
        <v-col cols="12" md="4">
          <v-select
            v-model="location"
            label="Select Location"
            :items="locations"
            outlined
            hide-details
            dense
          ></v-select>
        </v-col>
      </v-row> -->
      <vue-dropzone
        v-if="dropzoneOptions"
        :key="location"
        ref="VueDropzone"
        id="dropzone"
        :options="dropzoneOptions"
        :useCustomSlot="true"
        v-on:vdropzone-complete="onUploadComplete"
      >
        <div class="dropzone-content">
          <h3 class="dropzone-custom-title">Drag and drop to .xlsx files!</h3>
          <div class="subtitle">
            ...or click to select a file from your computer
          </div>
        </div>
      </vue-dropzone>
    </div>
  </v-container>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  name: "AddCell",
  components: {
    vueDropzone: vue2Dropzone,
  },

  data: (vm) => {
    return {
      office: "",
      // locations: ["Fairfield", "LA"],
      dropzoneOptions: null,
    };
  },

  mounted() {
    // console.log(this.location);
    this.office = this.selectedLocation;
    this.dropzoneOptions = {
      url: `simple/uploadsheet.php?location=${this.office}`,
      thumbnailWidth: 150,
      maxFilesize: 0.5,
      params: { locationdata: this.office },
    };
  },

  watch: {
    location(n) {
      this.dropzoneOptions = {
        url: `simple/uploadsheet.php?location=${n}`,
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        params: { locationdata: n },
      };
    },
  },

  methods: {
    onUploadComplete(data) {
      const { response } = data.xhr;
      if (response === "1") {
        this.$toast.success("Cells Uploaded Successfully");
      } else {
        this.$toast.error({ title: response, timer: 0 });
      }

      setTimeout(() => {
        if (this.$refs.VueDropzone?.removeAllFiles) {
          this.$refs.VueDropzone.removeAllFiles();
        }
      }, 5000);
    },
  },
};
</script>
<style>
.dropzone {
  height: 100%;
}
.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.addcell-content {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
  color: #00b782;
  font-size: 30px;
}

.subtitle {
  color: #314b5f;
}
</style>